import { useTranslation } from "react-i18next";
import { useHeaderSearch } from "../../hooks/useHeaderSearch";
import { HeaderSearchPanel } from "./HeaderSearchPanel";
import { useLocalizedNavigation } from "../../hooks/useLocalizedNavigation";

export const HeaderSearch = ({
  searchOpen,
  setSearchOpen,
  query,
  setQuery,
}) => {
  const { t } = useTranslation("header");
  const { results, isLoading } = useHeaderSearch(query, searchOpen);
  const { localizePath } = useLocalizedNavigation();
  const isSnapshot =
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

  const quickLinks = [
    { label: t("products"), path: localizePath("/products") },
    { label: t("contacts"), path: localizePath("/contacts") },
    { label: t("aboutUs"), path: localizePath("/aboutus") },
    { label: t("downloadArea"), path: localizePath("/downloadarea") },
    { label: t("recruitment"), path: localizePath("/recruitment") },
    { label: t("news"), path: localizePath("/news") },
  ].filter((item) => !(isSnapshot && item.path.endsWith("/recruitment")));

  return (
    <div className={`desktop__search ${searchOpen ? "desktop__search--open" : ""}`}>
      <HeaderSearchPanel
        query={query}
        setQuery={setQuery}
        quickLinks={quickLinks}
        results={results}
        isLoading={isLoading}
        autoFocus={searchOpen}
        onClose={() => {
          setSearchOpen(false);
          setQuery("");
        }}
        onSelect={() => {
          setSearchOpen(false);
          setQuery("");
        }}
      />
    </div>
  );
};
